import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-card',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="card">
      @if (title) {
        <div class="card-header">
          <h3>{{ title }}</h3>
          <ng-content select="[cardAction]"></ng-content>
        </div>
      }
      <div class="card-body">
        <ng-content></ng-content>
      </div>
    </div>
  `,
  styles: [`
    .card {
      background: #1c2128; border: 1px solid #21262d; border-radius: 10px;
      overflow: hidden; margin-bottom: 18px;
    }
    .card-header {
      display: flex; align-items: center; justify-content: space-between;
      padding: 14px 20px; border-bottom: 1px solid #21262d;
      background: rgba(255,255,255,.008);
    }
    .card-header h3 { margin: 0; font-size: 13px; font-weight: 600; }
    .card-body { padding: 18px 20px; }
  `],
})
export class CardComponent {
  @Input() title = '';
}
